import { createReducer, on } from '@ngrx/store';
import { IDialogState } from './dialog.model';
import { DialogActions } from './dialog.actions';

export interface DialogsState {
  dialogs: IDialogState[];
}

export const initialDialogState: DialogsState = {
  dialogs: [],
};

export const dialogReducer = createReducer(
  initialDialogState,
  on(DialogActions.openDialog, (state, { payload }) => {
    const newDialog: IDialogState = {
      config: payload.config,
      dialogId: payload.dialogId,
      dialogRef: undefined,
    };
    return {
      ...state,
      dialogs: [...state.dialogs, newDialog],
    };
  }),
  on(DialogActions.updateDialog, (state, { payload }) => {
    const updatedDialogs = state.dialogs.map((dialog) => {
      if (dialog.dialogId === payload.dialogId) {
        return {
          ...dialog,
          dialogRef: payload.dialogRef,
        };
      }
      return dialog;
    });
    return {
      ...state,
      dialogs: updatedDialogs,
    };
  }),
  on(DialogActions.closeDialog, (state, { payload }) => {
    const updatedDialogs = state.dialogs.filter(
      (dialog) => dialog.dialogId !== payload.dialogId
    );
    return {
      ...state,
      dialogs: updatedDialogs,
    };
  })
);
